import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Bar } from 'react-chartjs-2';

import { durationToSeconds } from '../../utils/duration-to-seconds';
import { secondsToHHMMSS } from '../../utils/seconds-to-hhmmss';

export default function AvgDurationPerYear() {
  const data = useStaticQuery(graphql`
    query {
      allEpisodesJson {
        group(field: fields___year) {
          totalCount
          fieldValue
          nodes {
            duration
            fields {
              year
            }
          }
        }
      }
    }
  `);

  const years = data.allEpisodesJson.group;
  const chartData = {
    labels: years.map((year) => year.fieldValue),
    datasets: [
      {
        label: 'Average duration',
        data: years.map(
          ({ totalCount, nodes }) =>
            nodes
              .map(({ duration }) => durationToSeconds(duration))
              .reduce((a, b) => a + b) / totalCount
        ),
        backgroundColor: ['#3b85f2'],
        barThickness: 16,
      },
    ],
  };

  const chartOptions = {
    indexAxis: 'y',
    scales: {
      x: {
        title: {
          display: true,
          text: 'Average duration (hours)',
          color: '#d1d5db',
        },
        max: 180 * 60,
        ticks: {
          color: '#d1d5db',
          count: 4,
          callback: function (value) {
            return `${(value / 60 / 60).toFixed(0)} h`;
          },
        },
        grid: {
          color: '#273045',
        },
      },
      y: {
        ticks: {
          color: '#d1d5db',
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            return `${label}: ${secondsToHHMMSS(context.parsed.x)}`;
          },
        },
      },
    },
  };

  return (
    <div className="mt-7 md:mt-0">
      <h3 className="text-2xl">Average duration per year</h3>
      <div className="mt-5 w-max border border-gray-700 hover:border-gray-600 shadow-2xl rounded-md p-5">
        <Bar data={chartData} options={chartOptions} />
      </div>
    </div>
  );
}
